import { render, staticRenderFns } from "./DepartmentsRegistryList.vue?vue&type=template&id=283f3470"
import script from "./DepartmentsRegistryList.vue?vue&type=script&lang=js"
export * from "./DepartmentsRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports